import {

    List,
    Datagrid,
    TextField, NumberField, ReferenceField, TopToolbar, CreateButton, ExportButton, useRecordContext, BooleanField,
    useDataProvider,
    DataProviderContext,
} from 'react-admin';
import FormattedDateTimeField from "../../../common/FormattedDateTimeField";
import { NoDataSection } from "../../../common/NoDataSection";
import { downloadCSV, jsonToCSV } from '../../../common/CSVExport';
import { format } from 'date-fns';
import MonthSelector from '../../../common/MonthSelector';
import { useMemo, useState } from 'react';
import { createCustomGoDataProvider } from '../../../services';

const myCustomExporter = (records: any) => {
    const data = records.map((record: any) => {
        return {
            ...record,
            started_date: format(new Date(record.started_date), 'dd-MMM-yyyy hh:mm a'),
            ended_at: format(new Date(record.ended_at), 'dd-MMM-yyyy hh:mm a'),
        };
    });
    const csv = jsonToCSV(data); // Convert the modified data to CSV format
    downloadCSV(csv, 'Tests Report');  // Download the CSV
};
const ReportTestsList = () => {
    const [selectedMonthRange, setSelectedMonthRange] = useState<{ firstDay: any, lastDay: any, month: any } | null>(null);
    const ListActions = () => (
        <TopToolbar className="">
            <MonthSelector monthsToShow={12} setSelectedMonthRange={setSelectedMonthRange} selectedMonthRange={selectedMonthRange} />
            <ExportButton />
        </TopToolbar>
    );
    const baseDataProvider = useDataProvider();
    const customDataProvider = useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'report_tests', apiEndpoint: '/test-series/reports/performance' },
            ]),
        [baseDataProvider],
    );
    const listFilter = selectedMonthRange
        ? { monthYear: selectedMonthRange.month }
        : {};

    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <List
                actions={<ListActions />}
                filter={listFilter}
                exporter={myCustomExporter}
                resource={'report_tests'}
                empty={<NoDataSection resource={'report_tests'} />}>
                <Datagrid bulkActionButtons={false}>
                    <TextField source="student.fullName" label="Name" />
                    <TextField source="student.email" label="Email" />
                    <TextField source="student.phone" label="Phone" />
                    <TextField source="test.name" label="Test" />
                    <TextField source="totalQuestionsAttempted" label="Attempted" />
                    <TextField source="totalIncorrectQuestions" label="Incorrect" />
                    <TextField source="totalCorrectQuestions" label="Correct" />
                    <TextField source="totalQuestions" label="Total Questions" />
                    <NumberField source="totalMarks" label="Total Marks" />
                </Datagrid>
            </List>
        </DataProviderContext.Provider>
    );
};
export default ReportTestsList;
